import { toast } from 'sonner';
import i18n from 'i18next';
import { ApiErrorException } from '@/api/client';

/**
 * Maps a backend error code to its user-facing message, in the interface's
 * language. The messages live in the `common:errors` catalogue, shared with
 * `services/errorMessage.ts`; extend it as new typed errors land on the
 * backend. A code the catalogue does not know falls back to the server's text.
 *
 * See REFACTORING_FRONTEND_PLAN.md §14.
 */
export function toUserMessage(err: unknown): string {
  if (err instanceof ApiErrorException) {
    const key = `common:errors.${err.code}`;
    return i18n.exists(key) ? i18n.t(key) : err.error.message;
  }
  if (err instanceof Error) return err.message;
  return i18n.t('common:errors.unknown');
}

export function showErrorToast(err: unknown): void {
  toast.error(toUserMessage(err));
}
